module.exports = __webpack_public_path__ + "img/about_a07.8c46a1e5.svg";